import { render, staticRenderFns } from "./GroupInvitationModal.vue?vue&type=template&id=72f2eeeb&scoped=true&"
import script from "./GroupInvitationModal.vue?vue&type=script&lang=js&"
export * from "./GroupInvitationModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupInvitationModal.vue?vue&type=style&index=0&id=72f2eeeb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f2eeeb",
  null
  
)

export default component.exports